<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <fg-input
          type="email"
          name="email"
          :class="email.type==='error'?'has-error':''"
          required
          label="E-mail:"
          placeholder="email@email.com"
          v-model="studentProfile.email"
          v-on:input="checkEmail()"
        >
        </fg-input>
        <label class="text-danger" v-if="email.type==='error'">
          {{ email.message }}
        </label>
      </div>
      <div class="col-md-4">
        <fg-input
          type="text"
          name="name"
          required
          label="Nome:"
          placeholder="Primeiro Nome"
          v-model="studentProfile.name"
        >
        </fg-input>
      </div>
      <div class="col-md-4">
        <fg-input
          type="text"
          name="surname"
          required
          label="Sobrenome:"
          placeholder="Sobrenome"
          v-model="studentProfile.surname"
        >
        </fg-input>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <fg-input
          type="text"
          :class="cpf.type==='error'?'has-error':''"
          required
          label="CPF:"
          placeholder="Somente Números"
          v-mask="'###.###.###-##'"
          v-model="studentProfile.cpf"
          v-on:input="checkCPF()"
        >
        </fg-input>
        <label class="text-danger" v-if="cpf.type==='error'">
          {{cpf.message}}
        </label>
      </div>
      <div class="col-md-4">
        <fg-input
          type="tel"
          required
          label="Data de Nascimento:"
          placeholder="##/##/####"
          v-mask="'##/##/####'"
          maxlength="10"
          v-model="studentProfile.birthdate"
        >
        </fg-input>
      </div>
      <div class="col-md-4">
        <label>Sexo: *</label>
        <br>
        <el-select
          class="select-primary col-md-12"
          required
          size="large"
          placeholder="Selecione Aqui..."
          v-model="studentProfile.gender"
        >
          <el-option
            v-for="option in selects.genders"
            class="select-danger"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          >
          </el-option>
        </el-select>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <label>Profissão: *</label>
        </br>
        <el-select
          class="select-primary col-md-12"
          required
          size="large"
          placeholder="Selecione Aqui..."
          v-model="studentProfile.job"
        >
          <el-option
            v-for="option in jobs"
            class="select-danger"
            :value="option"
            :label="option"
            :key="option"
          >
          </el-option>
        </el-select>
      </div>
      <div class="col-md-4">
        <fg-input
          type="text"
          required
          label="Telefone-Celular (Whatsapp):"
          placeholder="Somente Números"
          maxlength="11"
          v-model="studentProfile.cellphone"
        >
        </fg-input>
      </div>
      <div class="col-md-4">
        <fg-input
          type="text"
          label="Link Facebook:"
          placeholder="Digite aqui."
          v-model="studentProfile.facebook_link"
        >
        </fg-input>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-md-3">
        <fg-input
          type="text"
          required
          label="CEP:"
          placeholder="CEP - Somente Números"
          maxlength="8"
          v-model="studentProfile.cep"
        >
        </fg-input>
      </div>
      <div class="col-md-6">
        <fg-input
          type="text"
          required
          label="Endereço:"
          placeholder="Av. Endereço."
          v-model="studentProfile.address"
        >
        </fg-input>
      </div>
      <div class="col-md-3">
        <fg-input
          type="text"
          required
          label="Número:"
          placeholder="####"
          v-model="studentProfile.address_number"
        >
        </fg-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3">
        <fg-input
          type="text"
          label="Complemento:"
          placeholder="Complemento."
          v-model="studentProfile.address_complement"
        >
        </fg-input>
      </div>
      <div class="col-md-3">
        <label>País: *</label>
        </br>
        <el-select
          class="select-primary col-md-12"
          required
          size="large"
          placeholder="Selecione Aqui..."
          v-model="studentProfile.country"
        >
          <el-option
            v-for="(option) in countries"
            class="select-danger"
            :value="option.nome"
            :label="option.nome"
            :key="option.ordem"
          >
          </el-option>
        </el-select>
      </div>
      <div class="col-md-3">
        <label>Estado: *</label>
        </br>
        <el-select
          class="select-primary col-md-12"
          required
          size="large"
          placeholder="Selecione Aqui..."
          v-model="studentProfile.state"
          @change="setStateIndex()"
        >
          <el-option
            v-for="(option, index) in states"
            class="select-danger"
            :value="option.nome"
            :label="option.nome"
            :key="option.sigla"
          >
          </el-option>
        </el-select>
      </div>
      <div class="col-md-3">
        <label>Cidade: *</label>
        </br>
        <el-select
          class="select-primary col-md-12"
          required
          size="large"
          placeholder="Selecione Aqui..."
          v-model="studentProfile.city"
        >
          <el-option
            v-for="(option) in states[stateIndex].cidades"
            class="select-danger"
            :value="option"
            :label="option"
            :key="option"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-md-6">
        <fg-input
          type="password"
          required
          label="Senha:"
          placeholder="Deve conter no mínimo 6 dígitos"
          v-model="studentProfile.password"
        >
        </fg-input>
      </div>
      <div class="col-md-6">
        <fg-input
          type="password"
          required
          label="Confirmar Senha:"
          placeholder="Repita nova senha"
          v-model="studentProfile.password_confirmation"
        >
        </fg-input>
      </div>
    </div>
    <hr />
    <div class="text-center">
      <div class="text-danger">
        <p
          class="text-left"
          v-if="formErrors.length"
        >
          <b>Por favor, corrija o(s) seguinte(s) erro(s):</b>
          <ul>
            <li
              v-for="error in formErrors"
              :key="error"
            >{{ error }}</li>
          </ul>
        </p>
      </div>
      <br />
      <h5>
        <small class="text-danger pull-left">
          *Campo Obrigatório. Todos os campos obrigatórios devem ser preenchidos.
        </small>
      </h5>
      <br />
      <a
        href="http://res.cloudinary.com/toptrader/raw/upload/v1521742899/TERMOS_E_CONDI%C3%87%C3%95ES_DE_USO_TOP_TRADER_j97vhz.pdf"
        target="_blank"
      >
        Termos de Serviço
      </a>
      |
      <a
        href="http://res.cloudinary.com/toptrader/raw/upload/v1521825149/CONTRATO_DE_PRESTA%C3%87%C3%83O_DE_SERVI%C3%87OS_-_CURSO_ONLINE_2018_cak6te.pdf"
        target="_blank"
      >
        Contrato de Prestação de Serviço
      </a>
      <br />
      <checkbox v-model="agreeWithToS">
        Concordo com os Termos e Contrato de Prestação de Serviço
      </checkbox>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Loading, Select, Option } from 'element-ui'
import { mask } from 'vue-the-mask'
import { Checkbox, FadeRenderTransition } from 'src/components/index'
import AuthLayout from '../AuthLayout.vue'

// Utilities
import { BrazilianStates } from 'src//utils/modals/brazilian-states'
import { Countries } from 'src/utils/modals/countries'
import { Jobs } from 'src/utils/modals/jobs'

Vue.use(Loading.directive)

export default {
  components: {
    Checkbox,
    FadeRenderTransition,
    AuthLayout,
    [Select.name]: Select,
    [Option.name]: Option
  },
  directives: { mask },
  data () {
    return {
      agreeWithToS: false,
      formErrors: [],
      successMessage: '',
      loadingRegistration: false,
      email: {
        type: false,
        message: ''
      },
      cpf: {
        type: false,
        message: ''
      },
      studentProfile: {
        name: 'name',
        surname: 'surname',
        email: 'email@email.com',
        gender: 'M',
        job: 'job',
        cpf: '014.835.462-92',
        birthdate: '24/08/1992',
        cellphone: '91980798024',
        cep: '66085-148',
        address: 'Address',
        address_complement: 'Complment',
        address_number: '1130',
        city: 'Belem',
        state: 'PA',
        country: 'BRA',
        is_foreign_country: '0',
        facebook_link: '',
        password: '123456',
        password_confirmation: '123456'
      },
      selects: {
        genders: [
          { value: 'M', label: 'Masculino' },
          { value: 'F', label: 'Feminino' },
          { value: 'N', label: 'Prefiro não Informar' }
        ],
        isForeignCountry: [
          { value: 1, label: 'Sim' },
          { value: 0, label: 'Não' }
        ]
      },
      jobs: Jobs,
      countries: Countries,
      states: BrazilianStates.estados,
      stateIndex: 0
    }
  },
  methods: {
    checkEmail () {
      if (this.validEmail(this.studentProfile.email)) {
        this.axios
          .get('/student/check/email/' + this.studentProfile.email)
          .then(response => {
            if (response.data) { this.email = response.data }
          })
          .catch(error => {
            this.email.type = 'error'
            this.email.message = 'Erro ao validar e-mail informado. Entre em contato com suporte.'
            console.log(error)
          })
      }
    },
    checkCPF () {
      if (this.studentProfile.cpf.replace(/[^0-9]/g, '').length === 11) {
        this.axios
          .get('/student/check/cpf/' + this.studentProfile.cpf)
          .then(response => {
            if (response.data) { this.cpf = response.data }
          })
          .catch(error => {
            this.cpf.type = 'error'
            this.cpf.message = 'Erro ao validar CPF informado. Entre em contato com suporte.'
            console.log(error)
          })
      }
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    validate () {
      this.formErrors = []

      if (!this.agreeWithToS) {
        this.formErrors.push('É necessário concordar com os termos e contrato de prestação de serviço antes prosseguir.')
      }

      if (
        !this.studentProfile.name || !this.studentProfile.surname ||
        !this.studentProfile.email || !this.studentProfile.gender ||
        !this.studentProfile.job || !this.studentProfile.cpf ||
        !this.studentProfile.birthdate || !this.studentProfile.cellphone ||
        !this.studentProfile.cep || !this.studentProfile.address ||
        !this.studentProfile.address_number || !this.studentProfile.city ||
        !this.studentProfile.state || !this.studentProfile.country ||
        !this.studentProfile.password || !this.studentProfile.password_confirmation
      ) {
        this.formErrors.push('Todos os campos devem ser preenchidos obrigatoriamente.')
        if (!this.validEmail(this.studentProfile.email)) {
          this.formErrors.push('Utilize um e-mail válido.')
        }
        if ((this.studentProfile.cpf.replace(/[^0-9]/g, '').length !== 11) ||
          (!this.validCPF(this.studentProfile.cpf))) {
          this.formErrors.push('CPF inválido.')
        }
        if (this.studentProfile.password.length < 6) {
          this.formErrors.push('Campo senha deve conter no mínimo 6 caracteres.')
        }
        if ((this.studentProfile.password && this.studentProfile.password_confirmation) &&
          (this.studentProfile.password !== this.studentProfile.password_confirmation)) {
          this.formErrors.push('A senha de confirmação devem ser igual a senha definida.')
        }
        return false
      }

      if (!this.validEmail(this.studentProfile.email)) {
        this.formErrors.push('Utilize um e-mail válido.')
      }

      if ((this.studentProfile.cpf.replace(/[^0-9]/g, '').length !== 11) ||
          (!this.validCPF(this.studentProfile.cpf))) {
        this.formErrors.push('CPF inválido.')
      }

      if (this.studentProfile.password.length < 6) {
        this.formErrors.push('Campo senha deve conter no mínimo 6 caracteres.')
      }

      if (this.studentProfile.password !== this.studentProfile.password_confirmation) {
        this.formErrors.push('A senha de confirmação devem ser igual a senha definida.')
      }

      if (!this.formErrors.length) {
        if (this.studentProfile.country === 'Brasil') {
          this.studentProfile.is_foreign_country = 0
        } else {
          this.studentProfile.is_foreign_country = 1
        }
        this.$emit('on-validated', true, this.studentProfile)
        // Scroll to top
        var element = document.getElementById('topDiv')
        var top = element.offsetTop
        window.scrollTo(0, top)
        return true
      } else {
        return false
      }
    },
    setStateIndex () {
      let index = 0
      this.studentProfile.city = ''
      for (let state of this.states) {
        if (state.nome === this.studentProfile.state) {
          this.stateIndex = index
        }
        index++
      }
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    validCPF (cpf) {
      cpf = cpf.replace(/[^\d]+/g, '')
      if (cpf === '') return false
      // Elimina CPFs invalidos conhecidos
      if (cpf.length !== 11 ||
        cpf === '00000000000' ||
        cpf === '11111111111' ||
        cpf === '22222222222' ||
        cpf === '33333333333' ||
        cpf === '44444444444' ||
        cpf === '55555555555' ||
        cpf === '66666666666' ||
        cpf === '77777777777' ||
        cpf === '88888888888' ||
        cpf === '99999999999') { return false }
      // Valida 1o digito
      var add = 0
      for (var i = 0; i < 9; i++) { add += parseInt(cpf.charAt(i)) * (10 - i) }
      var rev = 11 - (add % 11)
      if (rev === 10 || rev === 11) { rev = 0 }
      if (rev !== parseInt(cpf.charAt(9))) { return false }
      // Valida 2o digito
      add = 0
      for (i = 0; i < 10; i++) { add += parseInt(cpf.charAt(i)) * (11 - i) }
      rev = 11 - (add % 11)
      if (rev === 10 || rev === 11) { rev = 0 }
      if (rev !== parseInt(cpf.charAt(10))) { return false }
      return true
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/WizardRecurringForms/FirstStep.vue